import { useEffect, useRef, useState } from "react";
import BackSecion from "../common/header";

import { Button, Form, Spinner, ToastContainer } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import apiEndpoint from "../../core/apiend_point";
import { getLocalStorage } from "../../core/localStorageService";
import { PayloadProps } from "../../core/schema";
import { triggerApi } from "../../services";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import ImageViewer from "react-simple-image-viewer";
import Toast from "react-bootstrap/Toast";

import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

/**
 * Renders Component.
//  * @return {HomeWorksStu} renders Component.
 */
export default function HomeWorksStu() {
  const [studentMessages, setStudentMessages] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [replyMessage, setReplyMessage] = useState<any>([]);
  const [replyMessageAttachments, setReplyMessageAttachments] = useState<any>(
    []
  );
  const [replyText, setReplyText] = useState<any>();
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [show, setShow] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [documentExtension, setDocumentExtension] = useState("");
  const [document, setDocument] = useState<any>([]);
  const [batchId, setBatchId] = useState("");
  const [showToast, setShowToast] = useState({
    show: false,
    messeage: "",
    headerlable: "",
  });
  const fileref: any = useRef(null);

  useEffect(() => {
    getStudentMessages();
  }, []);

  const getStudentMessages = () => {
    setIsLoading(true);
    // setIsLoginButton(true)
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        users_type_id: user?.student[0]?.users_type_id, //getLocalStorage('users_type_id'),
        page_count: 1,
        message_category_id: 2,
      },
      method: "POST",
      apiUrl: apiEndpoint.getStudentMessages,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.statusCode && res.statusCode === "success") {
          setStudentMessages(res.data);
        } else {
          console.log(res);
        }
        //   setIsLoginButton(false);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  function getReplies(reply: any) {
    setIsLoading(true);
    setBatchId(reply.batch_id);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        users_type_id: user?.student[0]?.users_type_id,
        batch_id: reply.batch_id,
      },
      method: "POST",
      apiUrl: apiEndpoint.studentMessagesReplies,
    };
    triggerApi(apiObject)
      .then((res: any) => {
        if (res.message && res.message === "success") {
          setReplyMessage(res.data.student_messages_reply);
          setReplyMessageAttachments(
            res.data.student_messages_reply_attachments
          );
        } else {
          setReplyMessage([]);
        }
        //   setIsLoginButton(false);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setShow(true);
      });
  }

  const handleUploadFiles = (event: any) => {
    // const uploaded = [...uploadedFiles];
    // if (uploaded.findIndex((f) => f.name === file.name) === -1) {
    //   uploaded.push(file);
    // }
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }

    setUploadedFiles(event.target.files[0]);
  };

  const sendReplay = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        "upload_files[]": uploadedFiles,
        reply: replyText,
        batch_id: batchId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: "POST",
      apiUrl: apiEndpoint.studentMsgsReply,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        console.log(res);
        if (res.statusCode && res.statusCode === "error") {
          // setStudentMessages(res.data);
          setShowToast({
            show: true,
            messeage: res.statusMsg,
            headerlable: "Alert",
          });
          getStudentMessages();
          setShow(false);
        } else {
          // console.log(res);
          getReplies({ batch_id: batchId });
        }
        setReplyText("");
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        fileref.current.value = null;
      });
  };

  return (
    <>
      <Container>
        <BackSecion name="Home Work" navigate_action="/home" />
        {/* <HomeWorkPdf /> */}
        {isLoading && (
          <div className="loader">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        {!isLoading &&
          studentMessages.length > 0 &&
          studentMessages.map((item: any, i: number) => {
            let msg_color = "notice_green";
            if (item.type === "Holiday Message") {
              msg_color = "concern_msg";
            }
            return (
              <div className="row mx-auto mt-4" key={i}>
                <div className={`sent_blue rounded-3 pt-2 pb-3 mb-2`}>
                  <p className="f-13 m-0 clr_lightgry">{item.name}</p>

                  <p className="f-11 clr_lightgry">
                    {item.user_name}
                    <span className="pl-3 pr-3"> | </span>
                    {moment(item.sent_date).format("DD MMM mm:ss a")}
                  </p>

                  {item.attachments && (
                    <Col
                      xs={12}
                      className="f-12 pb-3 center-content"
                      onClick={() => {
                        setDocument([item.attachments]);
                        setShowDocument(true);
                        let extension = item.attachments.split(".").pop();
                        setDocumentExtension(extension);
                      }}
                    >
                      <img
                        src={item.attachments}
                        alt=""
                        width="300px"
                        height="180px"
                      />
                    </Col>
                  )}
                  <Col xs={10} className="ps-0 pb-3 f-12">
                    {item.message}
                  </Col>
                  <div
                    className="text-center f-14 text-primary cursor"
                    onClick={() => getReplies(item)}
                  >
                    Reply
                  </div>
                </div>
              </div>
            );
          })}

        <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
          <Modal.Body>
            <div
              onClick={() => {
                setShow(false);
                setReplyMessage([]);
                setReplyMessageAttachments([]);
              }}
            >
              <BackSecion name="Home Work Message" />
            </div>
            <div>
              {show && (
                <Row className="row mx-auto mt-4">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={replyText}
                    onChange={(e: any) => setReplyText(e.target.value)}
                  />
                  <input
                    type="file"
                    // multiple
                    accept="application/pdf, image/png, image/jpeg, image/jpg"
                    onChange={handleUploadFiles}
                    ref={fileref}
                    className="custom-file-input mt-2"
                  />
                </Row>
              )}
              <Row className="mt-4">
                <Col xs={12} className="d-grid gap-2">
                  <Button variant="primary" type="button" onClick={sendReplay} disabled={!replyText}>
                    Reply
                  </Button>
                </Col>
              </Row>
              {show &&
                replyMessage.length > 0 &&
                replyMessage.map((item: any, i: number) => {
                  return (
                    <div className="row mx-auto mt-4" key={i}>
                      <div className={`sent_blue rounded-3 pt-2 pb-3 mb-2`}>
                        {/* <p className="f-13 m-0 clr_lightgry">{photo.name}</p> */}

                        <p className="f-11 clr_lightgry">
                          {/* {item.user_name}
                      <span className="pl-3 pr-3"> | </span> */}
                          {moment(item.date_added).format("DD MMM mm:ss a")}
                        </p>

                        {replyMessageAttachments[item.id] && (
                          <Col xs={12} className="f-12 pb-3 center-content">
                            <img
                              src={replyMessageAttachments[item.id][0].path}
                              alt=""
                              width="300px"
                              height="180px"
                            />
                          </Col>
                        )}
                        <Col xs={10} className="ps-0 pb-3 f-12">
                          {item.reply}
                        </Col>
                      </div>
                    </div>
                  );
                })}
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showDocument}
          fullscreen={true}
          onHide={() => setShowDocument(false)}
        >
          <Modal.Body>
            <div onClick={() => setShowDocument(false)}>
              <BackSecion name="Home Work Message" />
            </div>
            <div>
              {document !== "" && (
                <Row className="row mx-auto mt-4">
                  {documentExtension === "pdf" ? (
                    <Document
                      loading={`Loading...`}
                      file={document}
                      // onLoadSuccess={}
                    >
                      <Page pageNumber={1} />
                    </Document>
                  ) : (
                    <ImageViewer
                      src={document}
                      currentIndex={0}
                      disableScroll={false}
                      closeOnClickOutside={true}
                      onClose={() => {
                        setDocument([]);
                        setShowDocument(false);
                      }}
                      backgroundStyle={{ background: "transparent" }}
                    />
                  )}
                </Row>
              )}
            </div>
          </Modal.Body>
        </Modal>
        <ToastContainer
          className="p-3"
          position={"middle-center"}
          style={{ zIndex: 1 }}
        >
          <Toast
            show={showToast.show}
            onClose={() =>
              setShowToast({
                ...showToast,
                show: false,
                messeage: "",
                headerlable: "",
              })
            }
            bg={"danger"}
            autohide={true}
            delay={4000}
            animation={true}
          >
            <Toast.Header>
              <strong className="me-auto">{showToast.headerlable}</strong>
            </Toast.Header>
            <Toast.Body className="text-white">{showToast.messeage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </Container>
    </>
  );
}
